import React from 'react';

export const NetworkingLoungeConfig = {
    settings: {
        layout: {
            config: {
                header: { display: true },
                footer: { display: true },
                navbar: { display: true },
            },
        },
    },
    isPrivate: true,
    eventName: 'networking_lounge',
    routes: [
        {
            path: '/:organizationId/:eventSlug/networking-lounge',
            component: React.lazy(() => import('./NetworkingLounge')),
        },
    ],
};
